module.exports = __webpack_public_path__ + "media/images/logo_bw-4409fc1c4b2077839c9d2c18fa816099.png";